import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
import { useCookieConsent } from '../contexts/CookieConsentContext';

/**
 * PostHogPageView — fires a PostHog `$pageview` event on every React Router
 * navigation. Must be rendered inside `<BrowserRouter>` to access `useLocation`.
 *
 * PostHog's built-in pageview auto-capture only fires on hard browser
 * navigations, so it misses all client-side route changes in a SPA.
 * This component bridges that gap.
 *
 * Consent: gated on the "analytics" category. When the user has not opted in,
 * this component is a no-op. When they opt in, the next route change (or the
 * current route if the effect runs immediately after opt-in) will fire the
 * first pageview.
 *
 * It is also a no-op when PostHog was not initialised (i.e. VITE_POSTHOG_KEY
 * is absent in local dev).
 */
export default function PostHogPageView() {
  const location = useLocation();
  const { categories } = useCookieConsent();

  useEffect(() => {
    if (!categories.analytics) return;
    posthog.capture('$pageview', { $current_url: window.location.href });
  }, [location.pathname, location.search, categories.analytics]);

  return null;
}
